import $api from "http";
import { loadIdentityResponse } from './LoadIdentityService';

export async function getLoadByStatus(params) {
  return $api.get(`/tabel/load-by-status/`, { params }).then(loadIdentityResponse);
}

export async function getLoadHistory(params) {
  return $api.get(`/tabel/load-history/`, { params }).then(loadIdentityResponse);
}

export async function getLoadStatistics() {
  return $api.get(`/tabel/load-statistics/`);
}

export async function getLoadByTopBaseStatus(top_based, params) {
  return $api.get(`/tabel/loads-by-topbase/${top_based}/`, { params }).then(loadIdentityResponse);
}

export async function getLoadHistoryByTopBase(top_based, params) {
  return $api.get(`/tabel/load-history-by-topbase/${top_based}/`, { params }).then(loadIdentityResponse);
}

export async function getLoadStatisticsByTopBase(top_based) {
  return $api.get(`/tabel/load-statistics-by-topbase/${top_based}/`);
}

export async function getLoadsInLoading(params) {
  return $api.get(`/tabel/loads-in-loading/`, { params }).then(loadIdentityResponse);
}

export async function getLoadsInRoute(params) {
  return $api.get(`/tabel/loads-in-route/`, { params }).then(loadIdentityResponse);
}

export async function getLoadsCompleted(params) {
  return $api.get(`/tabel/loads-completed/`, { params }).then(loadIdentityResponse);
}

export async function markExit(loadId, data) {
  return $api.post(`/tabel/loads/${loadId}/mark-exit/`, data);
}

export async function updateLoadNotes(loadId, notes) {
  return $api.patch(`/tabel/loads/${loadId}/update-notes/`, { notes });
}

export async function completeTrip(loadId, notes, geo_b) {
  return $api.post(`/tabel/loads/${loadId}/complete-trip/`, { notes, geo_b });
}

export async function getLoadsTimeline(params) {
  return $api.get(`/tabel/loads-timeline/`, { params });
} 
